var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAttach = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M60 210c0 33.137 26.863 60 60 60s60-26.863 60-60V90c0-22.091-17.909-40-40-40s-40 17.909-40 40v80c0 5.523 4.477 10 10 10h10c5.523 0 10-4.477 10-10V90c0-5.523 4.477-10 10-10s10 4.477 10 10v120c0 16.569-13.431 30-30 30s-30-13.431-30-30V90c0-27.614 22.386-50 50-50s50 22.386 50 50v80c0 5.523 4.477 10 10 10h10c5.523 0 10-4.477 10-10V90c0-44.183-35.817-80-80-80S60 45.817 60 90z"
})));
export default SvgAttach;